import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setInvoiceModal, setInvoiceInfoModal } from '../actions/modalActions'
import { getTranslation } from '../../actions/dataActions'
import { createInvoice, getOriginalInvoice } from '../../actions/invoiceActions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import Ink from 'react-ink';
import * as resource from '../../constants/Resources'
import { setMessageModal } from '../../actions/generalActions'
import PropTypes from 'prop-types';

class InvoiceModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            receipts: [],
            checkedItems: [],
        };

        this.closeWindow = this.closeWindow.bind(this);
        this.invoiceAll = this.invoiceAll.bind(this);
        this.invoiceSelection = this.invoiceSelection.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    closeWindow() {
        this.props.setInvoiceModal(false, 100, []);
        this.setState({ checkedItems: [] });
    }

    invoiceAll() {
        const allReceiptIds = this.props.invoiceModal.receipts.map(rec => rec.ReceiptId.toString());
        this.setState({ checkedItems: allReceiptIds }, () => {
            this.processInvoices();
        });
    }

    invoiceSelection() {
        this.processInvoices();
    }

    processInvoices() {
        var receiptsToInvoice = [];
        this.props.invoiceModal.receipts.forEach(rec => {
            if (this.state.checkedItems.includes(rec.ReceiptId.toString())) {
                receiptsToInvoice.push(rec);
            }
        });

        let credits = receiptsToInvoice.filter(rec => rec.Credit === true);
        let invoices = receiptsToInvoice.filter(rec => !rec.Credit);

        if (credits.length > 0 && invoices.length > 0) {
            this.props.setMessageModal(true, this.props.getTranslation(resource.CREDIT_MIXED_NOT_ALLOWED));
            return;
        }

        if (credits.length > 1) {
            this.props.setMessageModal(true, this.props.getTranslation(resource.CREDIT_ONLY_ONE_ALLOWED));
            return;
        }

        const isCredit = credits.length === 1;

        this.props.setInvoiceInfoModal(
            true,
            isCredit,
            (originalInvoiceNumber, reference) => {
                if (isCredit) {
                    if (!originalInvoiceNumber || originalInvoiceNumber.trim() === "") {
                        this.props.setMessageModal(true, this.props.getTranslation(resource.NOT_VALID_INVOICENUMBER));
                        return;
                    }
                    const customerId = credits[0].CustomerId;
                    this.props.getOriginalInvoice(
                        customerId,
                        originalInvoiceNumber.trim(),
                        (invoice) => {
                            if (!invoice) {
                                this.props.setMessageModal(true, this.props.getTranslation(resource.NOT_VALID_INVOICENUMBER));
                                return;
                            } else {
                                credits[0].OriginalInvoiceNumber = invoice.InvoiceNumber || originalInvoiceNumber.trim();
                                this.props.setInvoiceInfoModal(false, false, null, [], null);
                                this.props.createInvoice(this.props.invoiceModal.invoiceType, credits, reference);
                                this.closeWindow();
                            }
                        },
                        () => {
                            this.props.setMessageModal(true, this.props.getTranslation(resource.NOT_VALID_INVOICENUMBER));
                        }
                    );
                } else {
                    if (invoices.length > 0) {
                        this.props.createInvoice(this.props.invoiceModal.invoiceType, invoices, reference);
                    }
                    this.props.setInvoiceInfoModal(false, false, null, [], null);
                    this.closeWindow();
                }
            },
            [],
            null
        );
    }

    handleChange(e) {
        const item = e.target.name;

        var items = [...this.state.checkedItems];
        var index = items.indexOf(item);

        if (index !== -1) {
            items.splice(index, 1);
            this.setState({ checkedItems: items });
        } else {
            this.setState({ checkedItems: [...this.state.checkedItems, item] });
        }
    }

    render() {
        const receipts = this.props.invoiceModal.receipts.length === 0? [<label key="no-invoices-label">Er zijn geen facturen die geprint kunnen worden!</label>]
            : this.props.invoiceModal.receipts.map((rec, index) => {
                const checked = this.state.checkedItems.indexOf(rec.ReceiptId.toString()) !== -1;
                const isCredit = rec.Credit === true;

                return (
                    <div className="receiptInfo" key={index}>
                        <div className="check">
                            <input
                                type="checkbox"
                                name={rec.ReceiptId.toString()}
                                checked={checked}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="details">
                            <label>Receipt: {rec.ReceiptId}  {isCredit && ` (${this.props.getTranslation(resource.CREDIT)})`}</label>
                            <label>Datum: {Intl.DateTimeFormat('nl-NL').format(new Date(rec.ReceiptDateTime))}</label>
                        </div>
                    </div>
                );
            });

        return (
            <Modal className='invoiceModal'
                contentLabel=""
                isOpen={!!this.props.invoiceModal.show}
                style={properties.invoiceModalStyle}
            >               
                <div className="invoiceModal_header">
                    <div className="header_top">
                        {this.props.getTranslation(resource.TO_INVOICE)}
                        <button className="header_close" onClick={this.closeWindow}>
                            <i className="icon remove" />
                            <Ink />
                        </button>
                    </div>

                </div>
                <div className="invoiceModal_receipts">
                    <div id="receipts" className="invoiceModal_scrollable receipts">
                        {receipts}
                    </div>
                </div>
                <div className="invoiceModal_footer">
                    <div className="btnLeft">
                        <button className="btnCancel" onClick={this.closeWindow} >
                            {this.props.getTranslation(resource.CANCEL)}
                        </button>
                    </div>
                    <div className="btnRight">
                        <button className="btnInvoiceSelection" onClick={this.invoiceSelection} >
                            {this.props.getTranslation(resource.SELECTION)}
                        </button>
                        <button className="btnInvoiceAll" onClick={this.invoiceAll} >
                            {this.props.getTranslation(resource.EVERYTHING)}
                        </button>
                    </div>
                </div>
            </Modal>
        )
    }
}

InvoiceModal.propTypes = {
    invoiceModal: PropTypes.object.isRequired,
    setInvoiceModal: PropTypes.func.isRequired,
    createInvoice: PropTypes.func.isRequired,
    getTranslation: PropTypes.func.isRequired,
    getOriginalInvoice: PropTypes.func.isRequired,
    setMessageModal: PropTypes.func.isRequired,
    setInvoiceInfoModal: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        invoiceModal: state.modalState.invoiceModal
    }
}

export default connect(
    mapStateToProps,
    { setInvoiceModal, createInvoice, getTranslation, getOriginalInvoice, setMessageModal, setInvoiceInfoModal }
)(InvoiceModal)


// WEBPACK FOOTER //
// src/modal/components/InvoiceModal.jsx